<div [ngClass]="{'preview-mode': previewMode}" class="section-container">
    <div class="section-header">
        <div class="title">
            Hardware
        </div>
    </div>


    <div *ngIf="model">
        <div class="module-group" *ngFor=" let offerTextModuleContainer of model?.offerTextModulesHardwareContainers"
             [ngClass]="{'unchecked': !offerTextModuleContainer.isChecked}">


            <bd-checkbox-squared
                [name]="'checkbox' + offerTextModuleContainer.id"
                [(ngModel)]="offerTextModuleContainer.isChecked"
                [disabled]="previewMode"
                [checkboxColor]="'rgb(25, 101, 225)'"
                [ngClass]="{'edit-mode': !previewMode}"
                (ngModelChange)="onCheckBoxClicked(offerTextModuleContainer)">
                {{getModuleTitle(offerTextModuleContainer.offerTextModule.textModuleType)}}
            </bd-checkbox-squared>

            <bd-labeled-textarea *ngIf="!previewMode"
                                 [(ngModel)]="offerTextModuleContainer.offerTextModule.text"
                                 [placeholder]=""
                                 [name]="'offerTextModule-textarea'+ offerTextModuleContainer.id"
                                 [ngClass]="{'is-visible':offerTextModuleContainer.isChecked}">
            </bd-labeled-textarea>

            <ng-container *ngIf="previewMode">
                <div class="text-preview" *ngIf="offerTextModuleContainer.isChecked">
                    {{offerTextModuleContainer.offerTextModule.text}}
                </div>
                <div class="empty-value-indicator" *ngIf="!offerTextModuleContainer.offerTextModule.text">–</div>
            </ng-container>


        </div>
    </div>

    <div class="divider"></div>

    <div class="section-header" [ngClass]="{'preview-mode': previewMode}">
        <div class="title">
            Verbrauchsmaterialien
        </div>
    </div>

    <div *ngIf="model">
        <div class="module-group" *ngFor=" let offerTextModuleContainer of model?.offerTextModulesSupplyContainers; last as isLast"
             [ngClass]="{'unchecked': !offerTextModuleContainer.isChecked, 'is-last': isLast}">


            <bd-checkbox-squared
                [name]="'checkbox' + offerTextModuleContainer.id"
                [(ngModel)]="offerTextModuleContainer.isChecked"
                [disabled]="previewMode"
                [checkboxColor]="'rgb(25, 101, 225)'"
                [ngClass]="{'edit-mode': !previewMode}"
                (ngModelChange)="onCheckBoxClicked(offerTextModuleContainer)">
                {{getModuleTitle(offerTextModuleContainer.offerTextModule.textModuleType)}}
            </bd-checkbox-squared>

            <bd-labeled-textarea *ngIf="!previewMode"
                                 [(ngModel)]="offerTextModuleContainer.offerTextModule.text"
                                 [placeholder]=""
                                 [name]="'offerTextModule-textarea'+ offerTextModuleContainer.id"
                                 [ngClass]="{'is-visible':offerTextModuleContainer.isChecked, 'is-last': isLast}">
            </bd-labeled-textarea>

            <ng-container *ngIf="previewMode">
                <div class="text-preview" *ngIf="offerTextModuleContainer.isChecked">
                    {{offerTextModuleContainer.offerTextModule.text}}
                </div>
                <div class="empty-value-indicator" *ngIf="!offerTextModuleContainer.isChecked">–</div>
            </ng-container>

        </div>
    </div>
</div>
